import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  
  constructor(private configurationService: ConfigurationService) { }

  ngOnInit(): void {
  }

  public getFooterText(): string {
    return this.configurationService.getFooterText();
  }
}
